import { Action } from 'redux';
import IAntiForgeryToken from '../../models/auth/AntiForgeryToken';

export const AUTH_SET_ANTI_FORGERY_TOKEN = 'AUTH_SET_ANTI_FORGERY_TOKEN';

export interface AuthSetAntiForgeryTokenAction extends Action {
  type: typeof AUTH_SET_ANTI_FORGERY_TOKEN;
  data: IAntiForgeryToken;
}

export type AntiForgeryTokenTypes = AuthSetAntiForgeryTokenAction;

export function setAntiForgeryToken(data: IAntiForgeryToken): AuthSetAntiForgeryTokenAction {
  return {
    type: AUTH_SET_ANTI_FORGERY_TOKEN,
    data,
  };
}
